<template>
  <div class="watermark" ref="watermark">
    <div
      class="water-item"
      v-for="(item, index) in waterList"
      :style="{
        top: `${item.top}px`,
        left: `${item.left}px`,
      }"
      :key="index"
    >
      <div class="flex flex-col" v-if="marketer_name">
        <span>{{ item.text }}</span>
        <span v-if="item.hasTime">{{ $Tool.formatDate(new Date()) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waterList: [],
      marketer_name: window.localStorage.getItem("userInfo")
        ? JSON.parse(window.localStorage.getItem("userInfo")).marketer_name
        : "",
      staffer_branch: window.localStorage.getItem("userInfo")
        ? JSON.parse(window.localStorage.getItem("userInfo")).staffer_branch ||
          ""
        : "",
    };
  },
  methods: {
    doWaterMark() {
      const itemW = 350;
      const itemH = 200;
      let w = 0;
      let h = 0;

      for (let i = 0; i < 80; i++) {
        if (h < window.innerHeight && w >= window.innerWidth) {
          w = 0;
          h += itemH;
        }
        this.waterList.push({
          top: h - itemH / 2,
          left: w,
          text: "课叮铛",
        });
        this.waterList.push({
          top: h,
          left: w + itemW / 2,
          text: `${this.marketer_name} ${this.staffer_branch}`,
          hasTime: true,
        });
        w += itemW;
      }
    },
  },

  watch: {
    $route() {
      let userInfo = window.localStorage.getItem("userInfo");
      if (userInfo) {
        this.marketer_name = JSON.parse(userInfo).marketer_name;
        this.staffer_branch = JSON.parse(userInfo).staffer_branch || "";
      }
      this.doWaterMark();
    },
  },
};
</script>

<style lang="less" scoped>
.watermark {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 10000000000;
  opacity: 0.1;
  overflow: hidden;
  .water-item {
    position: absolute;
    transform: rotateZ(-25deg);
    transform-origin: top right;
    color: #909399;
    height: 200px;
  }
}
</style>
